var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.615322 15.3848H7.20609",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4984 4.2771H9.90763",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4984 8.09863H8.05532",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4984 11.9202H6.81225",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07994 15.3847V2.08009C2.07994 1.6924 2.23379 1.31702 2.51071 1.04625C2.78763 0.775479 3.15686 0.615479 3.54456 0.615479H10.8676C11.2553 0.615479 11.6307 0.769325 11.9015 1.04625C12.1722 1.32317 12.3322 1.6924 12.3322 2.08009V5.86471",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5969 9.75409C10.5969 10.7202 11.3846 11.5079 12.3507 11.5079C13.3169 11.5079 14.1046 10.7202 14.1046 9.75409C14.1046 8.78794 13.3169 8.00024 12.3507 8.00024C11.3846 8.00024 10.5969 8.78794 10.5969 9.75409Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3507 15.3849C13.1507 15.3849 13.9138 15.3295 14.5969 15.2372C15.1569 15.1572 15.403 14.4987 15.0276 14.0741C14.3753 13.3295 13.4153 12.8618 12.3446 12.8618C11.2738 12.8618 10.3199 13.3295 9.66148 14.0741C9.28609 14.4987 9.53225 15.1572 10.0922 15.2372C10.7815 15.3357 11.5384 15.3849 12.3384 15.3849H12.3507Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBuildings);
export default __webpack_public_path__ + "static/media/all-buildings.da9b816c7bc5123cfb39ebb2715ddda9.svg";
export { ForwardRef as ReactComponent };